import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import Button from '@starbucks-web/pattern-library/lib/components/button';

import messages from './messages';
import { MAX_RECIPIENTS } from '../../utils/gift-form';
import { updateNumberOfRecipients } from '../../state/action-creators';

const MAX_RECIP_ID = 'maxRecipients';
const AddRecipient = ({ setRecipients, recipients, moveFocusOnClick }) => {
  const dispatch = useDispatch();
  return (
    <div className="text-center pb3">
      <p className="mb3" id={MAX_RECIP_ID}>
        <FormattedMessage {...messages.maxRecipients} />
      </p>
      {recipients.length < MAX_RECIPIENTS ? (
        <Button
          aria-describedby={MAX_RECIP_ID}
          color="black"
          data-e2e="add-recipient"
          onClick={() => {
            const newRecips = [
              ...recipients,
              {
                recipientEmail: '',
                recipientName: '',
                id: parseInt(new Date().getTime()),
              },
            ];
            setRecipients(newRecips);
            moveFocusOnClick(newRecips.length);
            dispatch(updateNumberOfRecipients(newRecips.length));
          }}
          visualStyle="positive"
        >
          <FormattedMessage {...messages.addRecipientButton} />
        </Button>
      ) : null}
    </div>
  );
};

export default AddRecipient;
